import React from 'react';

import {useDelayedVisibility} from './useDelayedVisibility';

export interface WithTransitionProps {
    isVisible: boolean;
}

export function withTransition<P extends object>(
    Component: React.ComponentType<P>,
    timeout: number,
    stateAfterTransition: 'unmount' | 'hide' = 'unmount',
) {
    return function WrappedWithTransition(props: P & WithTransitionProps) {
        const {isVisible, ...restProps} = props as WithTransitionProps;

        const areChildrenVisible = useDelayedVisibility(isVisible, timeout);

        if (!areChildrenVisible && stateAfterTransition === 'unmount') {
            return null;
        }

        return (
            <Component
                {...(restProps as P)}
                className={!areChildrenVisible && 'd-none'}
            />
        );
    };
}
